import type { RejectionGroundDto } from "../../autogen/bff-api";
import { isTenderRejectionGround } from "./rejectionGrounds";
import { getMarkdownFromTiptapContent } from "../input/TipTap/markdownUtils";

export const REJECTION_COMPLAINT_INFO =
  "Eventuell klage på avvisningen kan rettes til oppdragsgiver eller til Klagenemnda for offentlige anskaffelser (KOFA), Postboks 511 Sentrum, 5805 Bergen, eller per e-post post@kofa.no.";

export const supplierRejectionLead = (supplierName: string, grounds: RejectionGroundDto[]): string => {
  const supplier = supplierName.trim() || "leverandøren";
  const onlyTenderGrounds = grounds.length > 0 && grounds.every(isTenderRejectionGround);
  return onlyTenderGrounds
    ? `Tilbudet fra ${supplier} avvises med hjemmel i følgende bestemmelser:`
    : `Leverandøren ${supplier} avvises fra konkurransen med hjemmel i følgende bestemmelser:`;
};

export const buildSupplierRejectionMessageMarkdown = (
  supplierName: string,
  grounds: RejectionGroundDto[],
  messageByGroundKey: Record<string, string>,
) => {
  const sections = grounds
    .map((ground) => {
      const message = getGroundMessageMarkdown(
        messageByGroundKey[ground.key] ?? "",
      );

      return [`**${ground.foaReference}**`, ground.label, message]
        .filter(Boolean)
        .join("\n\n");
    })
    .join("\n\n");

  return [
    supplierRejectionLead(supplierName, grounds),
    sections,
    `**Klageadgang**\n\n${REJECTION_COMPLAINT_INFO}`,
  ]
    .filter(Boolean)
    .join("\n\n");
};

export const getGroundMessageMarkdown = (content: string) =>
  getMarkdownFromTiptapContent(content).trim();

export interface PrivateRejectionMessageContext {
  eventTitle: string;
  supplierContactName?: string | null;
  responsibleBuyerName?: string | null;
  buyerOrganizationName: string;
}

export const buildPrivateRejectionMessageMarkdown = (
  context: PrivateRejectionMessageContext,
  reasonMarkdown: string,
): string => {
  const title = context.eventTitle.trim() || "konkurransen";
  const contact = context.supplierContactName?.trim();
  const responsible = context.responsibleBuyerName?.trim();
  return [
    `**Emne:** Avvisning av tilbud — ${title}`,
    `Hei${contact ? ` ${contact}` : ""},`,
    `Vi viser til tilbudet deres i ${title}.`,
    reasonMarkdown.trim(),
    "Tilbudet går derfor ikke videre i konkurransen. Vi takker for interessen og for arbeidet dere har lagt ned.",
    `Har dere spørsmål til beslutningen, kan dere svare på denne meldingen eller ta kontakt med ${
      responsible ?? "oss"
    }.`,
    ["Med vennlig hilsen", responsible, context.buyerOrganizationName.trim()].filter(Boolean).join("  \n"),
  ]
    .filter(Boolean)
    .join("\n\n");
};
